import { Card, Collapse } from 'antd';
import { useParams } from 'react-router-dom';
import { memo, useState, useEffect } from 'react';
import { AlectifyTable } from '../../../../../../components';
import { fetchFinancialDocuments } from '../../../../../../services';
import useColumns from './effects/useColumns';
import { conditionForVendorAndItem } from '../../../../../../../static/utils';

const { Panel } = Collapse;

const VendorQuotes = memo(() => {
    const columns = useColumns();
    const { projectId } = useParams();
    const [documents, setDocuments] = useState({ data: null, fetching: false, total: 0 });

    const getFinancialDocuments = async (pagination) => {
        try {
            setDocuments({ ...documents, fetching: true });
            const params = {
                page: pagination?.page || 1,
                per_page: pagination?.per_page || 10,
                ordering:
                    pagination?.orderingColumn === 'vendor_estimate_associated_detail'
                        ? 'reason'
                        : pagination?.orderingColumn || null,
            };
            const modifiedSearchedColumns = conditionForVendorAndItem[pagination?.searchedColumn];
            if (pagination?.searchText && pagination?.searchedColumn) {
                if (modifiedSearchedColumns) {
                    modifiedSearchedColumns.forEach((modifiedColumn) => {
                        params[modifiedColumn] = pagination?.searchText;
                    });
                } else {
                    params[pagination?.searchedColumn] = pagination?.searchText;
                }
            }
            const response = await fetchFinancialDocuments(projectId, params);
            setDocuments({
                ...documents,
                fetching: false,
                data: response?.data,
                total: response.meta.total_count,
            });
        } catch (error) {
            setDocuments({ ...documents, fetching: false });
            console.log(error);
        }
    };

    useEffect(() => {
        getFinancialDocuments();
    }, [projectId]);

    return (
        <Card title="Vendor Quotes">
            <AlectifyTable
                columns={columns}
                defaultPageSize={10}
                total={documents.total}
                dataSource={documents.data}
                loading={documents.fetching}
                onDataFetch={getFinancialDocuments}
                selectRows={false}
            />
        </Card>
    );
});

export default VendorQuotes;
